
//const deeplApiKey = process.env.DEEPL_API_KEY;
const deeplApiKey = '2aeeffb5-95d9-451b-bbfa-1a51659695e4';

export const translateText = async (text, targetLang) => {
  const cacheKey = `${text}-${targetLang}`;
  const cachedTranslation = localStorage.getItem(cacheKey);

  // If the translation is already cached, return it
  if (cachedTranslation) {
    return cachedTranslation;
  }

  // If not cached, request from DeepL
  const url = `https://api.deepl.com/v2/translate`;
  const params = new URLSearchParams();
  params.append('auth_key', deeplApiKey);
  params.append('text', text);
  params.append('target_lang', targetLang.toUpperCase());

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });

    const data = await response.json();
    const translatedText = data.translations[0].text;

    // Cache the translated text in localStorage
    localStorage.setItem(cacheKey, translatedText);

    return translatedText;
  } catch (error) {
    console.error('Error translating text:', error);
    return text; // Return original text on error
  }
};
